import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_APPOINTMENT_PAYMENT,
    getAppointmentPaymentFail,
    getAppointmentPaymentSuccess
} from '../action/getAppointmentPaymentAction'

// api 
import getAppointmentPaymentApi from '../api/getAppointmentPaymentApi'

export function* getAppointmentPaymentSaga(action) {
    try {
        const response = yield call(() => getAppointmentPaymentApi(action.params))
        if (response.data.status === 1) {
            yield put(getAppointmentPaymentSuccess(response, action))
        } else {
            yield put(getAppointmentPaymentFail(response, action))
        }
    }
    catch (e) {
        yield put(getAppointmentPaymentFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_APPOINTMENT_PAYMENT, getAppointmentPaymentSaga)
}